export function getAgeType(name) {
    if(name === 'ADT')
      return 'adult'
    else if(name === 'CNN')
      return 'child'
    else if(name === 'INF')
      return 'infant'
    
    return name
}

export function convertPassengerType(name) {
  if(name === 'adult')
    return 'ADT'
  else if(name === 'child')
    return 'CNN'
  else if(name === 'infant')
    return 'INF'
  else if(name === 'infantSeated')
    return 'INS'
  
  return name
}
